// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { ProcessingSmsRouting } from './processing-sms.routing';
import { ProcessingSmsComponent } from './processing-sms.component';
import { ProcessingSmsService } from './services/processing-sms.service';
import { SmsBreadcrumbService } from './services/sms-breadcrumb.service';
import { TemplateListModule } from '../../shared/components/template-list/template-list.module';
import { ProcessingSmsFormModule } from './components/processing-sms-form/processing-sms-form.module';
import { SmsValidationModule } from './components/sms-validation/sms-validation.module';
import { HasSmsDataGuard } from './guards/has-sms-data.guard';
import { ProcessingValidationModule } from '../../shared/components/processing-validation/processing-validation.module';
import { ProcessingSmsResourceModule } from 'app_sasha/shared/resources/processing-sms-resource/processing-sms-resource.module';
import { BreadcrumbModule } from 'libraries/component/breadcrumb/breadcrumb.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import { HasSyscodesGuard } from 'app_sasha/shared/guards/has-syscodes.guard';

@NgModule({
    declarations: [
        ProcessingSmsComponent,
    ],
    imports: [
        CommonModule,
        ProcessingSmsRouting,
        ProcessingSmsResourceModule,
        BreadcrumbModule,
        TemplateListModule,
        ProcessingSmsFormModule,
        SmsValidationModule,
        ProcessingValidationModule,
        TitleServiceModule,
    ],
    providers: [
        ProcessingSmsService,
        SmsBreadcrumbService,
        HasSmsDataGuard,
        HasSyscodesGuard,
    ]
})
export class ProcessingSmsModule { }